import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import dayjs from 'dayjs';

import { NAME as name, CRUMB_LABEL_KEY, DEPENDENT_TABLES as depTableNames, DAILY_STATISTICS_BY_PAYMENT } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		WorkshopId: [] as DropdownItem[],
	},
	edit: {
		DateFrom: null as Date | null,
		WorkshopId: [] as number[],
		DateTo: null as Date | null,
	},
	localState: {
		fromDatePickerOptions: { disabledDate(time: Date) { return dayjs(time).isAfter(dayjs()); } },
	},
	depTableNames,
	depTableSettings: {
		[DAILY_STATISTICS_BY_PAYMENT]: {
			loadByEntityId: false,
			filter(state) {
				return {
					WorkshopId: state.edit.WorkshopId,
					DateFrom: state.edit.DateFrom,
					DateTo: state.edit.DateTo,
				};
			},
		},
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
	},
	props: {
		mode: null,
	},
});
